/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// back to top btn 
let mybutton = document.getElementById("upBtn");
window.onscroll = function() {scrollFunction()};
function scrollFunction() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}
function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}



let my_url = window.location.href;
if (my_url.match('/products/')) {

  if (document.querySelector('.block-swatch__radio')) {
    validate()
  }

  function validate() {
    let info_txt = document.querySelector('.size_unselected');
    let btn_submit = document.querySelector('button[data-action="add-to-cart"]');
    let btn_fake_submit = document.querySelector('div[type="fake_submit"]');

      if (!document.querySelector('.block-swatch__radio').checked) {
        btn_submit.classList.add('hide');
        btn_fake_submit.classList.remove('hide');
    } else {
      info_txt.classList.add('hide');
      btn_fake_submit.classList.add('hide');
      btn_submit.classList.remove('hide');
    }
  }

  function showInfo() {
    document.querySelector('.size_unselected').classList.remove('hide');
  }
}

if (my_url.match('/pages/chains')) {
  setTimeout(() => {
    (() => {
      (document.querySelectorAll('.chain-necklaces > a')).forEach(link => {
        link.hostname !== location.hostname && link.setAttribute('target', '_self');
      })
    })();
  }, 1000);
}


  /* Chains products */

  /* input */
  $('.custom_quantity-selector').on('propertychange input', function() {
    var get_val = $(this).val().trim();
    var get_total  = parseInt($(this).attr('data-inventory'));
    if(get_val > get_total) {
      $(this).val(get_total);
      $(this).parent('.custom_quantity_p').prev().css('display','inline-block');
    }
    else{
      $(this).parent('.custom_quantity_p').prev().css('display','none');
      $('#no_option').css('display','none');
    }
  });

  /* decrease btn */
  $('span.custom_minus').click(function(){
    var get_val = $(this).next().val();
    if (get_val >= 1) {
      get_val = parseInt(get_val) - parseInt(1);
      $(this).next().val(get_val);
    }
  $(this).parent('.custom_quantity_p').prev().css('display','none');
  });

  /* increase btn */
  $('.custom_add').click(function(){
    var get_val = $(this).prev().val().trim();
    var get_total  = parseInt($(this).attr('data-inventory'));
    if(get_val == '') {
      $(this).prev().val(1);
    }
    else if(get_val < get_total) {
      get_val = parseInt(get_val) + parseInt(1);
      $(this).prev().val(get_val);
    }
    else {
      $(this).parent('.custom_quantity_p').prev().css('display','inline-block');
    }
    $('#no_option').css('display','none');
  });

  var toAdd = new Array();
  $('.chains_add_button').click(function() {
    var check_true = 0;
    $('input.custom_quantity-selector').each(function() {
      var get_val = $(this).val().trim();
      if(get_val > 0) {
        check_true = 1;no_option
        return false;
      }
    });

    if(check_true == 1){
      var get_count = 0;
      $('input.custom_quantity-selector').each(function() {
        var get_val = $(this).val().trim();
        if(get_val > 0) {
          get_count = parseInt(get_count) + parseInt(get_val);
          toAdd.push({
            variant_id: $(this).attr('data-id'),
            quantity_id:$(this).val()
          });
          // console.log('toAdd:', no_option)
        }
      });
      moveAlong(toAdd);
      $('.chains_add_button span').text('Adding...');
    }
    else{
      $('#no_option').css('display','inline-block');
    }
  });

  function moveAlong(toAdd) {
    if (toAdd.length) {
      var request = toAdd.shift();
      var tempId = request.variant_id;
      var tempQty = request.quantity_id;
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + tempQty + '&id=' + tempId,
        dataType: 'json',
        success: function(line_item) {
          moveAlong(toAdd);
        },
        error: function(xhr, status, error) {
          console.log(xhr.responseText + status + error);
          moveAlong(toAdd);
        }
      };
      $.ajax(params);
    }
    else {
      $('.chains_add_button span').text('Add to cart');
       document.documentElement.dispatchEvent(new CustomEvent('product:added', {
         bubbles: true,
         detail: {
           quantity: 1
         }
       }));
    }
  }



// tried to change the sort filter "Size" 
// let filterSize = document.getElementById('#size');
// let content = filterSize.querySelectorAll('li');
// let list = [];
//   for (let i = 0; 1 < contents.length; i++) {
//     list.push(contents[i]);
//   }

//   list.sort(function(a, b){
//     let aa = parseInt(a.innerHTML);
//     let bb = parseInt(b.innerHTML);
//     return aa < bb ? -1 : (aa > bb ? 1 : 0);
//   });

//   list.reverse();

//   for (let i = 0; i < list.length.length; i++) {
//     console.log(list[i], filterSize.firstChild);
//   }
